import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// Scroll to top on route change, EXCEPT when only the language segment changes.
// Also skips scroll when navigating to a hash anchor.
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const prevRef = useRef({ pathname: null, hash: null });

  useEffect(() => {
    const prev = prevRef.current;
    prevRef.current = { pathname, hash };

    // Strip leading /it or /en to compare the "logical" path
    const stripLang = (p) => p.replace(/^\/(it|en)(?=\/|$)/, "") || "/";
    const prevLogical = prev.pathname ? stripLang(prev.pathname) : null;
    const nextLogical = stripLang(pathname);

    // If only the lang prefix changed, do NOT scroll
    if (prevLogical && prevLogical === nextLogical) return;

    // If navigating to a hash anchor, let the hash effect handle scrolling
    if (hash) return;

    if (typeof window !== "undefined") {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
    }
  }, [pathname, hash]);

  return null;
}
